import styled from 'styled-components/macro';
import StyledFlexContainer from './StyledFlexContainer';

const WorkItem = styled(StyledFlexContainer)`
	justify-content: flex-start;
	align-items: center;
	width: 380px;
	flex-direction: column;
	padding: 1rem;
	border-radius: 0.5rem;
	min-height: 400px;
	background-color: #fff;
	color: #000;
	cursor: pointer;
	border: 1px solid lightgray;
	transition: all 0.3s ease;
	&:hover {
		box-shadow: 0 0 25px rgba(0, 0, 0, 0.2);
	}
	@media screen and (min-width: 2000px) {
		width: 470px;
		padding: 1.25rem;
		border-radius: 0.75rem;
		min-height: 600px;
	}
	@media screen and (max-width: 300px) {
		width: 100%;
	}
`;
export default WorkItem;
